<template>
  <div id="app" :class="`${year === 2020 && month === 4 && date === 4?'gray':''}`">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />

    <Loading v-if="loadingStatus" />
    <Tip v-if="tipStatus" :message="tipMessage" :submit-event="tipSubmitCB" :tag="tipTag" />
    <Confirm v-if="confirmStatus" :content="confirmContent" :cancel-text="confirmCancelText" :submit-text="confirmSubmitText" :cancel-event="confirmCancelCB" :submit-event="confirmSubmitCB" />
    <Toast v-if="toastStatus" :message="toastMessage" :hide-event="hideToast" />

    <!-- 用户是否可进入社区 UI -->
    <UserSchedue />
  </div>
</template>

<script>
import Loading from "./components/Loading";
import Tip from "./components/Tip";
import Confirm from "./components/Confirm";
import Toast from "./components/Toast";

import UserSchedue from '@/views/components/UserSchedue.vue'

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { types as LoadingTypes } from "./store/modules/loading";
import { types as TipTypes } from "./store/modules/tip";
import { types as ConfirmTypes } from "./store/modules/confirm";
import { types as ToastTypes } from "./store/modules/toast";

export default {
  name: "app",
  data () {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      date: new Date().getDate()
    };
  },
  components: {
    Loading,
    Tip,
    Confirm,
    Toast,
    UserSchedue,
  },
  computed: {
    ...mapState({
      //confirm 组件需要的参数
      confirmStatus: state => state.confirm.status,
      confirmContent: state => state.confirm.content,
      confirmCancelCB: state => state.confirm.cancelCB,
      confirmSubmitCB: state => state.confirm.submitCB,
      confirmCancelText: state => state.confirm.cancelText,
      confirmSubmitText: state => state.confirm.submitText,

      //tip 组件
      tipTag: state => state.tip.tag,
      tipStatus: state => state.tip.status,
      tipMessage: state => state.tip.message,
      tipSubmitCB: state => state.tip.submitCB,

      //loading 组件
      loadingStatus: state => state.loading.status,

      //toast 组件
      toastStatus: state => state.toast.status,
      toastMessage: state => state.toast.message
    })
  },
  methods: {
    ...mapMutations({
      showLoading: LoadingTypes.SHOW,
      hideLoading: LoadingTypes.HIDE,

      showTip: TipTypes.SHOW,
      hideTip: TipTypes.HIDE,

      showConfirm: ConfirmTypes.SHOW,
      hideConfirm: ConfirmTypes.HIDE,

      showToast: ToastTypes.SHOW,
      hideToast: ToastTypes.HIDE
    })
  },
  create () { },
  mounted () {
    /**
     * confirm 调用方式
     */
    /*
    var dic = {
      content: "很多事",
      submitCB: () => {
        console.log("点了确定");
      },
      cancelCB: () => {
        console.log("点了取消");
      },
      submitText: "YES",
      cancelText: "NO"
    };
    this.showConfirm(dic);
    this.hideConfirm();
    */


    /**
     * tip 调用方式
     */
    /*
    var dic = {
      message: "我就是 tip",
      submitCB: () => {
        console.log("点了确定");
      }
    };
    this.showTip(dic);
    this.hideTip();
    */


    /**
     * loading 调用方式
     */
    /*
    this.showLoading();
    this.hideLoading();
    */


    /**
     * toast 调用方式
     */
    /*
    var dic = {
      message: "我就是 toast"
    };
    this.showToast(dic);
    */
  }
};
</script>

<style lang="less">
/*
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
*/
* {
  margin: 0;
  padding: 0;
  font-family: Arial, Helvetica, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  word-break: break-all;
  /*word-wrap: break-word;*/
  outline: none;
  /*-webkit-user-select: none;*/
  &.gray {
    -moz-filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    filter: gray; /* IE6-9 */
    filter: grayscale(100%);
  }
}
input,
textarea {
  -webkit-user-select: auto;
  resize: none;
}
ul,
li {
  list-style: none;
}
button {
  border: none;
  background: none;
  outline: none;
  -webkit-appearance: none;
}
font {
  line-height: initial;
}

input[type="number"] {
  -moz-appearance: textfield;
}
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  // overflow: auto;
}
@media screen and (max-width: 1200px) and (min-width: 1001px) {
  html {
    font-size: calc((100vw / 63));
  }
}

@media screen and (max-width: 1600px) and (min-width: 1200px) {
  html {
    font-size: calc(100vw / 80);
  }
}
@media screen and (min-width: 1600px) {
  html {
    font-size: 20px;
  }
}
</style>
